<template>
  <va-card title="Languages">
    <va-button
      :to="{ name: 'shkil-settings-languages-edit' }"
    >
      Додати
    </va-button>
    <va-data-table
      :fields="fields"
      :data="items"
      no-pagination
    >
      <template slot="marker" slot-scope="props">
        <va-icon name="fa fa-circle" :color="props.rowData.color" size="8px" />
      </template>

      <template slot="toggle" slot-scope="props">
        <va-toggle
          small
          v-on:input="togglePublished(props.rowData.id)"
          v-model="props.rowData.published"
        />
      </template>

      <template slot="toggle2" slot-scope="props">
        <va-toggle
          small
          v-on:input="toggleDefault(props.rowData.id)"
          v-model="props.rowData.is_default"
        />
      </template>

      <template slot="actions" slot-scope="props">
        <va-button
          small
          color="info"
          :to="{ name: 'shkil-settings-languages-edit', params: { id: props.rowData.id } }"
        >
          Редагувати
        </va-button>
        <va-button
          @click="remove(props.rowData.id)"
          small
          color="danger"
        >
          Видалити
        </va-button>
      </template>
    </va-data-table>
  </va-card>
</template>

<script>
import * as axios from 'axios'
import Vue from 'vue'

export default {
  data () {
    return {
      items: [],
    }
  },
  created () {
    this.fetch()
  },
  computed: {
    fields () {
      return [{
        name: 'label',
        title: 'Label',
        width: '15%',
      },
      {
        name: 'code',
        title: 'Code',
        width: '10%',
      },
      {
        name: 'locale',
        title: 'Locale',
        width: '10%',
      },
      {
        name: 'position',
        title: 'Позиція',
        width: '10%',
      },
      {
        title: 'Default',
        name: '__slot:toggle2',
        width: '15%',
      },
      {
        title: 'Опубліковано',
        name: '__slot:toggle',
        width: '15%',
      },
      {
        name: '__slot:actions',
        dataClass: 'text-right',
      }]
    },
    locale () {
      return Vue.i18n.locale()
    },
  },
  watch: {
    locale: function (value) {
      this.fetch()
    },
  },
  methods: {
    remove (id) {
      if (confirm('Дійсно видалити?')) {
        axios.delete(`${process.env.VUE_APP_SHKIL_API_URL}/admin/site-language/${id}?lang=${this.locale}`)
          .then(response => {
            const idx = this.items.findIndex(u => u.id === id)
            this.items.splice(idx, 1)
            this.showToast('Success')
          })
          .catch(error => {
            console.log(error)
            this.showToast('Error')
          })
      }
    },
    toggleDefault (id) {
      axios.put(`${process.env.VUE_APP_SHKIL_API_URL}/admin/site-language/${id}?lang=${this.locale}`, {
        is_default: this.items.find((item) => item.id === id).is_default ? 1 : 0,
      })
        .then(response => {
          this.showToast('Success')
        })
        .catch(error => {
          console.log(error)
          this.showToast('Error')
        })
    },
    togglePublished (id) {
      axios.put(`${process.env.VUE_APP_SHKIL_API_URL}/admin/site-language/${id}?lang=${this.locale}`, {
        published: this.items.find((item) => item.id === id).published ? 1 : 0,
      })
        .then(response => {
          this.showToast('Success')
        })
        .catch(error => {
          console.log(error)
          this.showToast('Error')
        })
    },
    fetch () {
      axios.get(`${process.env.VUE_APP_SHKIL_API_URL}/admin/site-language?lang=${this.locale}`)
        .then(response => {
          this.items = response.data
          this.items.forEach((item) => {
            item.published = !!item.published
            item.is_default = !!item.is_default
          })
        })
        .catch(error => {
          console.log(error)
          this.showToast('Error')
        })
    },
  },
}
</script>

<style lang="scss">
</style>
